import { useStore } from 'vuex'
import { ref, computed } from 'vue'
import { trackSelectItem } from 'foundation/js/ecommerceTracking'

export default {
    name: 'ProductCard',
    props: {
        data: {
            type: Object,
            required: true
        },
        showAddCta: {
            type: Boolean,
            default: false
        },
        listName: {
            type: String,
            required: false,
            default: null
        }
    },
    setup(props) {
        const store = useStore();

        var desktopImageUrl = computed(() => props.data.imageUrl + '?io=transform:fill,width:600,height:480')
        var mobileImageUrl = computed(() => props.data.imageUrl + '?io=transform:fill,width:400,height:320')
        const isSubmitting = ref(false);
        const isAdded = ref(false)

        const addToCart = async () => {

            if (!props.data.sku) {
                window.location.href = props.data.url
                return
            }
            
            if (isAdded.value || isSubmitting.value)
                return

            isSubmitting.value = true;
            await store.dispatch("basket/addToBasket", {
                sku: props.data.sku,
                quantity: 1
            })
            isSubmitting.value = false;
            isAdded.value = true;
        };

        const handleCardClick = () => {
            if (!props.listName) return
            const price = props.data.price ?? 0
            const beforePrice = props.data.beforePrice
            const discount = beforePrice && beforePrice > price
                ? Math.round((beforePrice - price) * 100) / 100
                : 0
            trackSelectItem({
                item_id: props.data.sku,
                item_name: props.data.title,
                item_brand: 'cancer.dk',
                price,
                discount,
                quantity: 1,
                index: 0
            }, props.listName)
        }

        return {
            desktopImageUrl,
            mobileImageUrl,
            isAdded,
            isSubmitting,
            addToCart,
            handleCardClick
        }
    }
}
